import { FlexBox } from '@airship-platform/jam-web/components';
import {
  SOWList,
  SOWQuery,
  SOWQueryEmptyState,
  SOWQueryProvider,
  useSOWQuery,
} from '@airship-platform/airship-proposal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../data-access/appointmentProposalOptions';
import QuickAddSOWButton from '../sow-query/QuickAddSOWButton';

const SOWQueryContent: React.FC = () => {
  const { currentOption } = useAppointmentProposalOptions();
  const { searchTerm, filteredSOWs } = useSOWQuery();

  const sowsWithActions = filteredSOWs.map((sow) => ({
    ...sow,
    actions: (
      <FlexBox alignItems={'center'} gap={1.5}>
        <Button
          component={Link}
          to={sow.sowId}
          color="softGold"
          sx={{
            width: ['100%', 'auto'],
            textTransform: 'none',
          }}
        >
          Add item
        </Button>
        <QuickAddSOWButton sow={sow} option={currentOption} color="softGold" />
      </FlexBox>
    ),
  }));

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      <Typography variant="h2">Statement of Work</Typography>
      <SOWQuery>
        <SOWQueryEmptyState
          searchTerm={searchTerm}
          isVisible={!filteredSOWs.length}
        />
        <FlexBox flexDirection={'column'} gap={2}>
          <Typography variant="body2">
            {sowsWithActions.length} results found
          </Typography>
          <SOWList sows={sowsWithActions} />
        </FlexBox>
      </SOWQuery>
    </FlexBox>
  );
};

const SOWQueryPage: React.FC = () => (
  <SOWQueryProvider>
    <SOWQueryContent />
  </SOWQueryProvider>
);

export default SOWQueryPage;
